import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { AbstractAddComponent } from '../../../shared/abstracts/add/abstract-add/abstract-add.component';
import { IAppointment, IPatient, IReference } from '@ahryman40k/ts-fhir-types/lib/R4';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'inc-appointment-add',
  templateUrl: './appointment-add.component.html',
  styleUrls: ['./appointment-add.component.scss'],
})
export class AppointmentAddComponent extends AbstractAddComponent<{ appointment: IAppointment, files: File[] }> implements OnInit {
  @Input() patient: IPatient;
  @Input() examinations: string[];
  @Input() isModal: boolean;
  @Input() user: any;
  supportingInformation: IReference[];

  files: File[] = [];
  editParticipant: any;

  constructor(private modalController: ModalController) {
    super();
  }

  ngOnInit() {
    if (this.user) {
      this.form.controls.participant.setValue([
        {
          actor: {
            reference: this.user.uid,
            display: this.user.displayName
          }
        },
        {
          actor: {
            reference: this.patient.id,
            display: this.patient.name[0].text
          }
        }
      ]);
      if (this.inData) {
        this.editParticipant = this.form.controls.participant.value[0];
        this.supportingInformation = this.inData.appointment.supportingInformation;
        this.form.patchValue(this.inData.appointment ? this.inData.appointment : null);
        this.files = this.inData.files ? this.inData.files : [];
      }
    }
  }

  close(data?: IAppointment) {
    if (data) {
      data.requestedPeriod[0].start = new Date(data.requestedPeriod[0].start).toISOString();
      if (this.supportingInformation) {
        data.supportingInformation = this.supportingInformation;
      }
      if (data.participant.length > 2 && this.editParticipant) {
        data.participant[2] = this.editParticipant;
      } else if (data.participant.length === 2 && this.editParticipant) {
        data.participant.push(this.editParticipant);
      }
      data.meta = { lastUpdated: new Date().toISOString() };
    }
    if (this.isModal) {
      data ? this.modalController.dismiss({ appointment: data, files: this.files }) : this.modalController.dismiss();
    } else {
      this.save({appointment: data, files: this.files});
    }
  }

  resetForm() {
    return new FormGroup({
      id: new FormControl(),
      created: new FormControl(new Date().toISOString()),
      status: new FormControl('active'),
      requestedPeriod: new FormArray([
        new FormGroup({
          start: new FormControl(new Date().toISOString()),
          end: new FormControl('')
        })
      ]),
      description: new FormControl(),
      serviceType: new FormArray([
        new FormGroup({
          coding: new FormArray([
            new FormGroup({
              code: new FormControl(''),
              display: new FormControl(''),
              system: new FormControl('')
            })
          ]),
          text: new FormControl('')
        })
      ]),
      participant: new FormArray([
        new FormGroup({
          actor: new FormGroup({
            reference: new FormControl(''),
            display: new FormControl('')
          })
        }),
        new FormGroup({
          actor: new FormGroup({
            reference: new FormControl(''),
            display: new FormControl('')
          })
        })
      ])
    });
  }
}
